import { render, staticRenderFns } from "./passwordForm.vue?vue&type=template&id=2bb2b67d&scoped=true&"
import script from "./passwordForm.vue?vue&type=script&lang=js&"
export * from "./passwordForm.vue?vue&type=script&lang=js&"
import style0 from "./passwordForm.vue?vue&type=style&index=0&id=2bb2b67d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb2b67d",
  null
  
)

export default component.exports